export function decodePolyline(encoded) {
  if (!encoded) return [];

  let index = 0;
  let lat = 0;
  let lng = 0;
  const points = [];

  while (index < encoded.length) {
    let shift = 0;
    let result = 0;
    let byte = 0;

    do {
      byte = encoded.charCodeAt(index++) - 63;
      result |= (byte & 0x1f) << shift;
      shift += 5;
    } while (byte >= 0x20);

    const deltaLat = result & 1 ? ~(result >> 1) : result >> 1;
    lat += deltaLat;

    shift = 0;
    result = 0;

    do {
      byte = encoded.charCodeAt(index++) - 63;
      result |= (byte & 0x1f) << shift;
      shift += 5;
    } while (byte >= 0x20);

    const deltaLng = result & 1 ? ~(result >> 1) : result >> 1;
    lng += deltaLng;

    points.push({ lat: lat / 1e5, lng: lng / 1e5 });
  }

  return points;
}

export async function fetchRoadRoutePath(origin, destination) {
  if (!origin || !destination) return null;

  const originParam = `${origin.lng},${origin.lat}`;
  const destinationParam = `${destination.lng},${destination.lat}`;
  const url = `https://router.project-osrm.org/route/v1/driving/${originParam};${destinationParam}?overview=full&geometries=polyline`;

  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Route request failed: ${response.status}`);
  }

  const data = await response.json();
  const geometry = data?.routes?.[0]?.geometry;
  if (!geometry) return null;

  return decodePolyline(geometry);
}